if (!customElements.get('kana-gallery')) customElements.define('kana-gallery', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort(); this.controller = new AbortController();
    const signal = this.controller.signal;
    this.track = this.querySelector('[data-gallery-track]');
    this.slides = [...this.querySelectorAll('[data-gallery-slide]')];
    this.buttons = [...this.querySelectorAll('[data-gallery-index]')];
    this.dialog = this.querySelector('dialog'); this.index = 0;
    if (!this.track || !this.slides.length) return;
    this.addEventListener('click', e => {
      const b = e.target.closest('button'); if (!b || !this.contains(b)) return;
      if (b.hasAttribute('data-gallery-prev')) this.go(this.index - 1);
      if (b.hasAttribute('data-gallery-next')) this.go(this.index + 1);
      if (b.hasAttribute('data-gallery-index')) this.go(Number(b.dataset.galleryIndex));
      if (b.hasAttribute('data-gallery-open')) { this.returnFocus = b; this.open(Number(b.dataset.galleryOpen)); }
      if (b.hasAttribute('data-gallery-close')) this.dialog.close();
      if (b.hasAttribute('data-gallery-zoom')) {
        const zoomed = this.dialog.classList.toggle('is-zoomed');
        b.setAttribute('aria-pressed', String(zoomed));
      }
    }, { signal });
    const keys = e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1)); }
      if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); this.go(e.key === 'Home' ? 0 : this.slides.length - 1); }
    };
    this.track.addEventListener('keydown', keys, { signal });
    this.dialog.addEventListener('keydown', keys, { signal });
    this.track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => { if (!this.dialog.open) this.update(); });
    }, { signal, passive: true });
    for (const name of ['contextmenu', 'dragstart']) this.addEventListener(name, e => e.preventDefault(), { signal });
    this.dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = this.oldOverflow ?? '';
      this.returnFocus?.focus(); this.go(this.index, true);
    }, { signal });
    this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, { signal });
    const viewport = this.dialog.querySelector('[data-lightbox-view]');
    viewport.addEventListener('touchstart', e => { this.touch = [e.touches[0].clientX, e.touches[0].clientY]; }, { signal, passive: true });
    viewport.addEventListener('touchend', e => {
      if (!this.touch || this.dialog.classList.contains('is-zoomed')) return;
      const dx = e.changedTouches[0].clientX - this.touch[0], dy = e.changedTouches[0].clientY - this.touch[1];
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.4) this.go(this.index + (dx < 0 ? 1 : -1));
      this.touch = null;
    }, { signal, passive: true });
    viewport.addEventListener('wheel', e => {
      if (this.dialog.classList.contains('is-zoomed')) return;
      const delta = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : (e.shiftKey ? e.deltaY : 0);
      if (Math.abs(delta) > 20 && Date.now() - (this.lastWheel || 0) > 400) { this.lastWheel = Date.now(); this.go(this.index + (delta > 0 ? 1 : -1)); }
    }, { signal, passive: true });
    this.observer = new ResizeObserver(() => { if (!this.dialog.open) this.update(); }); this.observer.observe(this.track); this.controls();
  }
  go(index, instant = false) {
    const wrapped = index < 0 || index >= this.slides.length;
    this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
    if (this.dialog.open) this.showImage();
    else this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: instant || wrapped || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    this.controls();
  }
  update() {
    let best = Infinity;
    this.slides.forEach((s, i) => { const d = Math.abs(s.offsetLeft - this.slides[0].offsetLeft - this.track.scrollLeft); if (d < best) { best = d; this.index = i; } }); this.controls();
  }
  open(index) {
    this.index = index; this.oldOverflow = document.documentElement.style.overflow;
    this.showImage(); this.dialog.showModal(); document.documentElement.style.overflow = 'hidden'; this.controls();
  }
  showImage() {
    const source = this.slides[this.index].querySelector('img'), image = this.dialog.querySelector('img');
    image.src = this.slides[this.index].querySelector('[data-gallery-open]').dataset.largeSrc || source.currentSrc || source.src; image.alt = source.alt;
    this.dialog.classList.remove('is-zoomed'); this.dialog.querySelector('[data-gallery-zoom]').setAttribute('aria-pressed', 'false');
    this.dialog.querySelector('[data-lightbox-view]').scrollTo({ top: 0, left: 0 });
  }
  controls() {
    this.dialog.dataset.kanaWatermarked = String(this.index > 0);
    this.querySelectorAll('[data-gallery-prev], [data-gallery-next]').forEach(b => b.disabled = this.slides.length < 2);
    this.querySelectorAll('[data-gallery-status]').forEach(s => s.textContent = (this.dataset.counter || 'Bild {current} von {total}').replace('{current}', this.index + 1).replace('{total}', this.slides.length));
    this.buttons.forEach((b, i) => b.setAttribute('aria-current', String(i === this.index)));
  }
  disconnectedCallback() { if (this.dialog?.open) { this.dialog.close(); document.documentElement.style.overflow = this.oldOverflow ?? ''; } this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); }
});
